import { render, staticRenderFns } from "./TeacherClass.vue?vue&type=template&id=322c3306&"
import script from "./TeacherClass.vue?vue&type=script&lang=js&"
export * from "./TeacherClass.vue?vue&type=script&lang=js&"
import style0 from "./TeacherClass.vue?vue&type=style&index=0&id=322c3306&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports